import React, { useCallback, useRef } from "react";
import { Icon } from "semantic-ui-react";
import { Key } from "../../../../BytebeamClient";
import { useOutsideClickHandler } from "../../../../hooks/useOutsideClickHandler";
import { StyledButtonWithBorder } from "../../DeviceManagement/Devices/Devices";
import ActionDisplayDropdown from "../ActionsV3/ActionDisplayDropdown";

interface ActionDisplaySectionProps {
  showActionDisplayDropdown: boolean;
  setShowActionDisplayDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  allowedMetadataKeys: Key[];
  metadataKeysToShow: string[];
  setMetadataKeysToShow: React.Dispatch<React.SetStateAction<string[]>>;
  displayButtonStyle?: React.CSSProperties;
  /**
   * Position of the dropdown panel relative to the trigger button.
   * @default "right"
   */
  panelPosition?: "left" | "right";
}

const ActionDisplaySection: React.FC<ActionDisplaySectionProps> = ({
  showActionDisplayDropdown,
  setShowActionDisplayDropdown,
  allowedMetadataKeys,
  metadataKeysToShow,
  setMetadataKeysToShow,
  displayButtonStyle,
  panelPosition = "right",
}) => {
  const wrapperRef = useRef(null);
  const displayButtonRef = useRef(null);

  const toggleDropdown = () => {
    setShowActionDisplayDropdown((prev) => !prev);
  };

  const handleOutsideClick = useCallback(() => {
    setShowActionDisplayDropdown(false);
  }, [setShowActionDisplayDropdown]);

  useOutsideClickHandler([wrapperRef, displayButtonRef], handleOutsideClick);

  return (
    <div
      style={
        displayButtonStyle
          ? displayButtonStyle
          : {
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              margin: "20px 0",
            }
      }
    >
      <div style={{ position: "relative" }}>
        <StyledButtonWithBorder
          onClick={toggleDropdown}
          ref={displayButtonRef}
          style={{
            padding: "10.5px",
          }}
        >
          <Icon name="desktop" style={{ margin: 0 }} />
        </StyledButtonWithBorder>
        {showActionDisplayDropdown && (
          <div ref={wrapperRef}>
            <ActionDisplayDropdown
              allowedMetadataKeys={allowedMetadataKeys}
              metadataKeysToShow={metadataKeysToShow}
              setMetadataKeysToShow={setMetadataKeysToShow}
              panelPosition={panelPosition}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionDisplaySection;
